import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */
/**
 * @module FetchPurchaseOrders
 */

/**
 *
 * @param {Object} props
 */

const useFetchPurchaseOrder = () => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)

  const fetchData = useCallback(() => {
    setLoading(true)
    axios
      .get(`efactura/purchaseorder/lov/efacturascompras`)
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { response, error, loading, refetch: fetchData }
}

export default useFetchPurchaseOrder
